import { get, set, del } from "idb-keyval"; // can use anything: IndexedDB, Ionic Storage, etc.

export const idbKeyvalStorage = {
  setItem: (name: string, value: string | number | boolean | Uint8Array) => {
    return set(name, value);
  },
  getItem: (name: string) => {
    return get(name);
  },
  removeItem: (name: string) => {
    return del(name);
  },
};
